import cn from 'classnames';

import PlayVideoTutorialWithThumb from 'components/common/playVideoTutorial/PlayVideoTutorialWithThumb';
import EmbedYoutube from 'components/embedYoutubeModal';
import { youtubeThumbnailGenerator } from 'helpers/common';
import useToggle from 'hooks/useToggle';
import { referralBonusSelector } from 'selectors/referralBonusSelector';
import { useAppSelector } from 'storeHooks';

import styles from './withdrawIndia.module.scss';

const MIN_REFERRAL_COMMISSION_THRESHOLD = 0;

export const videoMetaData = {
  video: 'https://www.youtube.com/embed/Lmm3J_UEjfs?si=nzh2nEctV-OpIMSA?rel=0&autoplay=1',
  title: 'How to withdraw funds to your bank account',
  thumbnail: youtubeThumbnailGenerator('Lmm3J_UEjfs'),
  duration: '0:51',
};

const VideoTutorial = () => {
  const [videoPlay, toggleVideoPlay] = useToggle(false);

  const referralBonus = useAppSelector(referralBonusSelector) || -1;
  const hasValidReferralBonus = Number(referralBonus) > MIN_REFERRAL_COMMISSION_THRESHOLD;

  return (
    <>
      <PlayVideoTutorialWithThumb
        onPlay={toggleVideoPlay}
        testId="playWithdrawalTutorialButtonIndia"
        metaData={videoMetaData}
        customClassName={cn({ [styles.tutorial]: hasValidReferralBonus })}
      />
      <EmbedYoutube
        src={videoMetaData.video}
        onClose={toggleVideoPlay}
        isOpen={videoPlay}
      />
    </>
  );
};

export { VideoTutorial };
